import React, { Component } from 'react';
import { connect } from 'react-redux';

// Actions
import {
    fetchDeviceForMeter,
    fetchHomeDetailMeters,
    onAddOrEditDeviceModalIsShown,
    onDeleteDeviceForMeter,
    onDeleteMeter,
    onUndeleteDeviceForMeter,
    onUndeleteMeter,
} from '../../../data/homes/actions';
import { fetchMeterTypes, fetchMqttAccessApi, fetchWaPiProperties } from '../../../data/meters/actions';
import { fetchAllDeviceTypes } from '../../../data/deviceTypes/actions';
import { fetchAllSwitches } from '../../../data/switch/actions';

// Selectors
import {
    getAddOrEditDeviceModalIsShown,
    getHomeDetailMetersAreLoading,
    getHomeDetailMetersData,
} from '../../../data/homes/selectors';
import { selectedLangageSelector } from '../../../data/app/selector';
import { getSwitchList } from '../../../data/switch/selectors';

// Components
import { Alert, Button, Card, Empty, Icon, Modal, Spin, Table, Tooltip } from 'antd';
import AddOrEditMeterModal from './AddOrEditMeterModal';
import AddOrEditDeviceModal from './AddOrEditDeviceModal';
import WaPiPropertiesModal from './WaPiPropertiesModal';
import moment from 'moment';

// Other
import { getDisplayLabelForMeterType } from '../../../utils';
import { strings } from '../../../localization';
import MergeDeviceModal from './MergeDeviceModal';
import MqttAccessApiModal from './MqttAccessApiModal';

function toReadableDate(ts){
    return ts ? moment(ts).format('YYYY-MM-DD') : '---';
}

const ButtonGroup = Button.Group;
class MetersTab extends Component {
    state = {
        addOrEditModalIsShown: false,
        deleteModalShown: false,
        deleteModalIsLoading: false,
        isDeletingDevice: false,
        recordToDelete: null,
        recordToEdit: null,
        recordDeviceToEdit: null,
        selectedMeterForDevice: null,
        waPiPropsIsShown: false,
        waPiPropsText: '',
        mqttAccessApiShown: false,
        mqttAccessApi: undefined,
        alertIsShown: false,
        recordDeviceModalIsShown: false,
    };

    componentWillMount() {
        const { params, fetchHomeDetailMeters, fetchMeterTypes, fetchAllDeviceTypes } = this.props;
        fetchHomeDetailMeters(params);
        fetchMeterTypes();
        fetchAllDeviceTypes();
    }

    onDeleteModalShownToggle = (isShown, meterRecord, deviceRecord) => () => {
        if (deviceRecord) {
            this.setState({
                isDeletingDevice: true,
                recordToDelete: deviceRecord
            });
        } else {
            this.setState({
                isDeletingDevice: false,
                recordToDelete: meterRecord
            });
        }
        this.setState({ deleteModalShown: isShown });
    };

    onDeleteModalStateReset = () => {
        this.setState(() => ({
            deleteModalShown: false,
            deleteModalIsLoading: false,
            isDeletingDevice: false,
            recordToDelete: null
        }));
    };

    fetchDevicesAndSwitchesForMeterIfNeeded = (expanded, record) => {
        if (expanded && !record.deleted) {
            const { fetchDeviceForMeter, fetchAllSwitches } = this.props;
            fetchAllSwitches(record.meter);
            fetchDeviceForMeter(record.meter);
        } else {
            return false;
        }
    };

    toggleAddOrEditModal = (isShown, record) => () => {
        if (record && isShown) {
            this.setState({ recordToEdit: record });
        } else if (!isShown) {
            this.setState({ recordToEdit: null });
        }

        this.setState({ addOrEditModalIsShown: isShown })
    };

    toggleAddOrEditDevice = (isShown, meterRecord, deviceRecord) => () => {
        if (meterRecord && isShown) {
            this.setState({ recordDeviceToEdit: null, selectedMeterForDevice: meterRecord });
        }
        if (deviceRecord && isShown) {
            this.setState({
                recordDeviceToEdit: deviceRecord,
                selectedMeterForDevice: meterRecord
            });
        } else if (!isShown) {
            this.setState({ recordDeviceToEdit: null, selectedMeterForDevice: null });
        }

        const { onAddOrEditDeviceModalIsShown } = this.props;
        onAddOrEditDeviceModalIsShown(isShown);
    };

    toggleMergeDevice = (isShown, meterRecord, deviceRecord) => () => {
        if (deviceRecord && isShown) {
            this.setState({
                recordDeviceToEdit: deviceRecord,
                selectedMeterForDevice: meterRecord
            });
        } else if (!isShown) {
            this.setState({ recordDeviceToEdit: null, selectedMeterForDevice: null });
        }

        this.setState({
            recordDeviceModalIsShown: isShown,
        });
    };

    onDeleteMeterDevice = () => {
        this.setState({ deleteModalIsLoading: true });

        const { recordToDelete, isDeletingDevice } = this.state;
        const {
            params,
            fetchHomeDetailMeters,
            fetchDeviceForMeter,
            onDeleteDeviceForMeter,
            onUndeleteDeviceForMeter,
            onDeleteMeter,
            onUndeleteMeter,
            switches,
        } = this.props;
        // console.log(recordToDelete);
        if (isDeletingDevice) {
            if (recordToDelete.deleted) {
                onUndeleteDeviceForMeter(recordToDelete.id).then(() => {
                    this.onDeleteModalStateReset();
                    fetchDeviceForMeter(recordToDelete.meterPkey || recordToDelete.meter.id);
                });
            } else {
                const switchList = switches || [];
                const switchAttached = switchList.find(currentSwitch => (currentSwitch.relays && currentSwitch.relays.find(relay => (relay.device === recordToDelete.id))));
                if (switchAttached) {
                    this.setState({ alertIsShown: true });
                    this.onDeleteModalStateReset();
                } else {
                    onDeleteDeviceForMeter(recordToDelete.id).then(() => {
                        this.onDeleteModalStateReset();
                        fetchDeviceForMeter(recordToDelete.meterPkey || recordToDelete.meter.id);
                    });
                }
            }
        } else if (!isDeletingDevice && recordToDelete.deleted) {
            onUndeleteMeter(recordToDelete.id, params).then(() => {
                this.onDeleteModalStateReset();
                fetchHomeDetailMeters(params);
            });
        } else if (!isDeletingDevice && !recordToDelete.deleted) {
            onDeleteMeter(recordToDelete.id, params).then(() => {
                this.onDeleteModalStateReset();
                fetchHomeDetailMeters(params);
            });
        }
    };

    renderExpandedRow = (record, index) => {
        if (record.deleted) {
            const { msgs } = this.props;
            return (
                <Empty
                    description={<span>{msgs.homes.detail.canNotFetchDevicesForDeletedMeter}</span>}
                    style={{ margin: '30px auto' }}
                />
            );
        }
        let deviceType = 'deviceType.name';
        const {lang} = this.props;
        switch(lang){
            case 'en':
                break;
            case 'de':
                deviceType = 'deviceType.name_de';
                break;
            case 'sk':
                deviceType = 'deviceType.name_sk';
                break;
            case 'zh':
                deviceType = 'deviceType.name_zh';
                break;
            default:
        }
        const { msgs, metersData } = this.props;
        const deviceIsLoading = metersData[index].devices.isLoading;
        const deviceData = metersData[index].devices.data;

        const columns = [
            { title: msgs.homes.detail.deviceName, dataIndex: 'name', key: 'name' },
            {
                title: msgs.homes.detail.deviceQuality,
                key: 'quality',
                dataIndex: 'quality'
            },
            { title: msgs.homes.detail.deviceType, dataIndex: deviceType, key: 'type' },
            { title: msgs.homes.detail.deviceCountLabel, dataIndex: 'count', key: 'count' },
            {
                title: msgs.actionsLabel,
                key: 'action',
                className: 'text-right',
                render: (text, deviceRecord) => (
                    <span style={{ float: 'right' }}>
                        {!deviceRecord.deleted && (
                            <ButtonGroup>
                                {/* Only show merge button if there's more than 1 device */}
                                {record.devices.data.length > 1 &&
                                    <Button
                                        size="small"
                                        type="secondary"
                                        onClick={this.toggleMergeDevice(true, record, deviceRecord)}
                                        style={{ marginRight: 10 }}
                                    >
                                        <Icon type="pull-request" />
                                        Merge device
                                    </Button>
                                }
                                <Button
                                    size="small"
                                    type="primary"
                                    ghost
                                    onClick={this.toggleAddOrEditDevice(true, record, deviceRecord)}
                                    style={{ marginRight: 10 }}
                                >
                                    <Icon type="edit" />
                                    {msgs.homes.detail.editDeviceButton}
                                </Button>
                            </ButtonGroup>
                        )}
                        {deviceRecord.deleted ? (
                            <ButtonGroup>
                                <Button
                                    size="small"
                                    type="danger"
                                    ghost
                                    onClick={this.onDeleteModalShownToggle(true, null, deviceRecord)}
                                >
                                    <Icon type="undo" /> {msgs.undelete}
                                </Button>
                            </ButtonGroup>
                        ) : (
                            <ButtonGroup>
                                <Button
                                    size="small"
                                    type="danger"
                                    ghost
                                    onClick={this.onDeleteModalShownToggle(true, null, deviceRecord)}
                                >
                                    <Icon type="delete" />
                                </Button>
                            </ButtonGroup>
                        )}
                    </span>
                )
            }
        ];

        if (deviceData.length > 0 && !deviceIsLoading) {
            return (
                <Table
                    style={{ marginBottom: 20 }}
                    columns={columns}
                    size="middle"
                    rowClassName={record => {
                        if (record.deleted) {
                            return 'ant-table-deleted-row';
                        }
                    }}
                    isLoading={deviceIsLoading}
                    dataSource={deviceData}
                    pagination={false}
                />
            );
        }

        return (
            <Empty
                description={<span>{msgs.homes.detail.noDevicesOnMonitor}</span>}
                style={{ margin: '30px auto' }}
            />
        );
    };

    toggleWaPiPropsModal = (isShown, waPiPropsText = '') => this.setState({waPiPropsIsShown: isShown, waPiPropsText});

    toggleMqttAccessModal = (isShown, mqttAccessApi = '') => this.setState({mqttAccessApiShown: isShown, mqttAccessApi});

    isAllowedToEdit = () => {
        const { isAdmin, isOwnerOfHouse, isInstaller } = this.props;
        return isAdmin || isOwnerOfHouse || isInstaller;
    };

    render() {
        const {
            metersDataAreLoading,
            metersData,
            msgs,
            ownerData,
            params,
            isAdmin,
            addOrEditDeviceModalIsShown,
            fetchWaPiProperties,
            fetchMqttAccessApi
        } = this.props;
        const {
            addOrEditModalIsShown,
            recordToDelete,
            deleteModalShown,
            selectedMeterForDevice,
            recordToEdit,
            recordDeviceToEdit,
            deleteModalIsLoading,
            isDeletingDevice,
            waPiPropsIsShown,
            waPiPropsText,
            mqttAccessApiShown,
            mqttAccessApi,
            alertIsShown,
            recordDeviceModalIsShown,
        } = this.state;
        const columns = [
            {
                title: 'ID',
                dataIndex: 'id',
                key: 'id'
            },
            {
                title: msgs.homes.detail.meterName,
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: msgs.homes.detail.meterMacAddress,
                dataIndex: 'macAddress',
                key: 'macAddress'
            },
            {
                title: msgs.homes.detail.meterReadingsPerMinute,
                dataIndex: 'readingsPerMinute',
                key: 'readingsPerMinute',
                render: text => `${text} / ${msgs.perMinute}`
            },
            {
                title: msgs.homes.detail.meterType,
                className: 'type',
                key: 'type',
                render: (text, record) => (
                    <grid>{getDisplayLabelForMeterType(record.type)}</grid>
                )
            },
            {
                title: msgs.homes.detail.subscriptionType,
                dataIndex: 'subscriptionType',
                key: 'subscriptionType',
                render: text => text === 'P' ? 'PREMIUM' : text === 'S' ? 'STANDARD' : 'BASIC'
            },
            {
                title: msgs.homes.detail.subscriptionUntil,
                dataIndex: 'subscriptionUntil',
                key: 'subscriptionUntil',
                render: toReadableDate
            },
            {
                title: msgs.homes.detail.purpose,
                dataIndex: 'purpose',
                key: 'purpose'
            },
            {
                title: msgs.homes.detail.flavor,
                dataIndex: 'modbusFlavor',
                key: 'modbusFlavor'
            },
            {
                title: msgs.homes.detail.capacity,
                dataIndex: 'capacity',
                key: 'capacity'
            },
            {
                title: msgs.homes.detail.installationDate,
                dataIndex: 'installationDate',
                key: 'installationDate',
                render: toReadableDate
            },
            {
                title: msgs.actionsLabel,
                className: 'text-right',
                key: 'action',
                render: (text, record) => (
                    <span style={{ float: 'right' }}>
                        {!record.deleted && (record.type === 'iWattController' || record.type === 'iWattControllerV3' || record.type === 'SmartPi') && (
                            <ButtonGroup style={{ marginRight: 10 }}>
                                <Tooltip title="wa-pi properties" placement='bottom'>
                                    <Button
                                        type="default"
                                        onClick={() => fetchWaPiProperties(record.id, txt => this.toggleWaPiPropsModal(true, txt))}
                                    >
                                        <Icon type="setting" />
                                    </Button>
                                </Tooltip>
                            </ButtonGroup>
                        )}
                        {!record.deleted && (
                            <ButtonGroup style={{ marginRight: 10 }}>
                                <Tooltip title="Mqtt Access API" placement='bottom'>
                                    <Button
                                        type="default"
                                        onClick={() => fetchMqttAccessApi(record.id, txt => this.toggleMqttAccessModal(true, txt))}
                                    >
                                        {'API'}
                                    </Button>
                                </Tooltip>
                            </ButtonGroup>
                        )}
                        {!record.deleted && (
                            <ButtonGroup style={{ marginRight: 10 }}>
                                <Button
                                    type="primary"
                                    onClick={this.toggleAddOrEditDevice(true, record)}
                                >
                                    <Icon type="plus" />
                                    {msgs.homes.detail.addDeviceButton}
                                </Button>
                            </ButtonGroup>
                        )}
                        {!record.deleted && (
                            <ButtonGroup style={{ marginRight: 10 }}>
                                <Button
                                    type="primary"
                                    disabled={!this.isAllowedToEdit()}
                                    onClick={this.toggleAddOrEditModal(true, record)}
                                >
                                    <Icon type="edit" />
                                </Button>
                            </ButtonGroup>
                        )}
                        {record.deleted ? (
                            <ButtonGroup>
                                <Button
                                    type="danger"
                                    ghost
                                    onClick={this.onDeleteModalShownToggle(true, record)}
                                >
                                    <Icon type="undo" /> {msgs.undelete}
                                </Button>
                            </ButtonGroup>
                        ) : (
                            <ButtonGroup style={{ marginRight: 10 }}>
                                <Button
                                    type="danger"
                                    disabled={!this.isAllowedToEdit()}
                                    onClick={this.onDeleteModalShownToggle(true, record)}
                                >
                                    <Icon type="delete" />
                                </Button>
                            </ButtonGroup>
                        )}
                    </span>
                )
            }
        ];

        return alertIsShown
            ?
                <Alert
                message={strings.homes.detail.errorAlertTitle}
                description={strings.homes.detail.errorAlertMessage}
                type="error"
                showIcon
                closable
                style={{margin: 30}}
                onClose={() => this.setState({ alertIsShown: false })} />
            : [
                <Card
                    loading={metersDataAreLoading}
                    key="users-table-card"
                    bodyStyle={{ padding: 0 }}
                    title={
                        !metersDataAreLoading &&
                        ownerData &&
                        `${msgs.homes.detail.owner}: ${ownerData.get('name')} ${ownerData.get('surename')}`
                    }
                    extra={
                        metersDataAreLoading
                            ? undefined
                            : [
                                <Button
                                    key="add-detail-meter"
                                    size="large"
                                    type="primary"
                                    onClick={this.toggleAddOrEditModal(true)}
                                >
                                    <Icon type="plus" />
                                    {msgs.homes.detail.addMeterButton}
                                </Button>
                            ]
                    }
                >
                    {metersData && !metersDataAreLoading ? (
                        <Table
                            pagination={false}
                            dataSource={metersData}
                            columns={columns}
                            rowClassName={record => {
                                if (record.deleted) {
                                    return 'ant-table-deleted-row';
                                }
                            }}
                            onExpand={this.fetchDevicesAndSwitchesForMeterIfNeeded}
                            expandedRowRender={this.renderExpandedRow}
                        />
                    ) : (
                        <Empty
                            description={<span>{msgs.noDataAvailable}</span>}
                            style={{ margin: '30px auto' }}
                        />
                    )}
                </Card>,
                waPiPropsIsShown &&
                <WaPiPropertiesModal
                    key="wa-pi-props"
                    msgs={msgs}
                    onCancel={() => this.toggleWaPiPropsModal(false)}
                    isShown={waPiPropsIsShown}
                    isLoading={false}
                    content={waPiPropsText}
                />,
                mqttAccessApiShown &&
                <MqttAccessApiModal
                    key="mqttAccessApi"
                    msgs={msgs}
                    onCancel={() => this.toggleMqttAccessModal(false)}
                    isShown={mqttAccessApiShown}
                    isLoading={false}
                    content={mqttAccessApi}
                />,
                addOrEditModalIsShown && (
                    <AddOrEditMeterModal
                        key="add-or-edit-meter-modal"
                        msgs={msgs}
                        onCancel={this.toggleAddOrEditModal(false)}
                        onAfterSubmit={this.toggleAddOrEditModal(false)}
                        recordToEdit={recordToEdit}
                        params={params}
                        isShown={addOrEditModalIsShown}
                    />
                ),
                addOrEditDeviceModalIsShown && (
                    <AddOrEditDeviceModal
                        key="add-or-edit-device-modal"
                        msgs={msgs}
                        isAdmin={isAdmin}
                        onCancel={this.toggleAddOrEditDevice(false)}
                        recordToEdit={recordDeviceToEdit}
                        meterId={selectedMeterForDevice.meter}
                        params={params}
                        isShown={addOrEditDeviceModalIsShown}
                    />
                ),
                recordDeviceModalIsShown && (
                    <MergeDeviceModal
                        key="merge-device-modal"
                        hideModal={this.toggleMergeDevice(false)}
                        recordToEdit={recordDeviceToEdit}
                        meter={selectedMeterForDevice}
                        isShown={recordDeviceModalIsShown}
                        reloadPage={() => this.componentWillMount()}
                    />
                ),
                recordToDelete && (
                    <Modal
                        key="delete-user-modal"
                        visible={deleteModalShown}
                        onCancel={this.onDeleteModalStateReset}
                        onOk={this.onDeleteMeterDevice}
                        okText={recordToDelete.deleted ? msgs.undelete : msgs.delete}
                        okType={recordToDelete.deleted ? 'primary' : 'danger'}
                        confirmLoading={deleteModalIsLoading}
                        cancelText={msgs.close}
                        title={
                            isDeletingDevice
                                ? recordToDelete.deleted
                                    ? msgs.sureToUndeleteTitle
                                    : msgs.homes.detail.deleteDeviceModalTitle
                                : recordToDelete.deleted
                                    ? msgs.sureToUndeleteTitle
                                    : msgs.homes.detail.deleteMeterModalTitle
                        }
                    >
                        <Spin spinning={deleteModalIsLoading} size="large">
                            <div>
                                <p>
                                    {isDeletingDevice
                                        ? msgs.homes.detail.deleteDeviceConfirmDescription[0]
                                        : msgs.homes.detail.deleteMeterConfirmDescription[0]}{' '}
                                    <strong>{recordToDelete.name}</strong>
                                    &nbsp;
                                    {recordToDelete.deleted
                                        ? msgs.homes.detail.undeleteDeviceOrMeter
                                        : msgs.homes.detail.deleteMeterConfirmDescription[1]}
                                </p>
                            </div>
                        </Spin>
                    </Modal>
                )
            ];
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        metersData: getHomeDetailMetersData(state),
        metersDataAreLoading: getHomeDetailMetersAreLoading(state),
        addOrEditDeviceModalIsShown: getAddOrEditDeviceModalIsShown(state),
        switches: getSwitchList(state),
        lang: selectedLangageSelector(state)
    }),
    {
        fetchHomeDetailMeters,
        fetchDeviceForMeter,
        fetchMeterTypes,
        onDeleteMeter,
        onUndeleteDeviceForMeter,
        onUndeleteMeter,
        onDeleteDeviceForMeter,
        onAddOrEditDeviceModalIsShown,
        fetchAllDeviceTypes,
        fetchWaPiProperties,
        fetchMqttAccessApi,
        fetchAllSwitches,
    }
)(MetersTab);